import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { VoucherToolCall } from '../types';

interface VoucherCard extends LinkCardRecord {
  displayName: string | null;
  status: string;
}

interface VoucherCardsProps {
  toolCalls: VoucherToolCall[];
}

export function VoucherCards({ toolCalls }: VoucherCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path}>
          {(voucher: VoucherCard) => (
            <>
              <div className="fw-semibold text-truncate">{voucher.displayName}</div>
              <Badge appearance="muted" variant="secondary">{voucher.status}</Badge>
            </>
          )}
        </LinkCard>
      ))}
    </>
  );
}
